import { UseMutationExecute } from 'urql';
import {
  CreateTeachingLoadFactorMutation,
  CreateTeachingLoadFactorMutationVariables,
  TeachingLoadFactorInput,
  UpdateTeachingLoadFactorMutation,
  UpdateTeachingLoadFactorMutationVariables,
  ValueMode,
} from '../../../types/planung-graphql-client-defs';
import { SchoolYearWithoutHolidayType } from '../../SchoolYear/graphql/types';
import { FactorsFormType, TeachingLoadFactorType } from '../types/factorTypes';

export function interpreteAsNumber(input: string): string {
  let factor = 1; // default

  const isFraction = input.search('/') > -1; //  4/54

  if (isFraction) {
    const parts = input.split('/');
    const numerator = parseFloat(parts[0].replace(',', '.'));
    const denominator = parseFloat(parts[1].replace(',', '.'));
    factor = numerator / denominator;
  }

  if (!isFraction) {
    factor = parseFloat(input.replace(',', '.'));
  }

  factor = isNaN(factor) ? 0 : factor;

  // 7 Nachkommastellen
  return factor.toFixed(7);
}

export function numberOrUndefined(value: unknown): number | undefined {
  if (typeof value === 'number' && !isNaN(value)) {
    return value;
  }
  if (typeof value === 'string') {
    const parsed = parseFloat(value);
    if (!isNaN(parsed)) {
      return parsed;
    }
  }
  return undefined;
}

export async function submitFactor(
  values: FactorsFormType,
  teachingLoadFactor: TeachingLoadFactorType | null,
  currentSchoolYear: SchoolYearWithoutHolidayType | null,
  context: { additionalTypenames: string[] },
  updateTeachingLoadFactor: UseMutationExecute<
    UpdateTeachingLoadFactorMutation,
    UpdateTeachingLoadFactorMutationVariables
  >,
  createTeachingLoadFactor: UseMutationExecute<
    CreateTeachingLoadFactorMutation,
    CreateTeachingLoadFactorMutationVariables
  >,
) {
  // Der Teilungs-Faktor gilt nur, wenn Eingabe und errechneter Wert beide da sind.
  const hasPartial = !!values.valuePartialRaw && !!values.valuePartial;

  // Das Backend ersetzt den Faktor vollständig; eine leere Liste heißt „gilt für alle“.
  const input: TeachingLoadFactorInput = {
    schoolYearUuid: currentSchoolYear?.uuid ?? '',
    comment: values.comment,
    factorType: values.factorType,
    active: values.active,
    grades: values.grades,
    value: parseFloat(values.value),
    valueRaw: values.valueRaw,
    valuePartial: hasPartial ? parseFloat(values.valuePartial ?? '') : null,
    valuePartialRaw: hasPartial ? values.valuePartialRaw : null,
    valueMode: values.valueMode ?? ValueMode.UnitCount,
    studentsMin: numberOrUndefined(values.studentsMin),
    studentsMax: numberOrUndefined(values.studentsMax),
    studentsPartialMin: numberOrUndefined(values.studentsPartialMin),
    studentsPartialMax: numberOrUndefined(values.studentsPartialMax),
    subjectUuids: values.subjects ?? [],
    subjectContainerUuids: values.subjectContainers ?? [],
    gradeGroupUuids: values.gradeGroups ?? [],
    timeGridEntryUuids: values.timeGridEntries ?? [],
    teacherUuids: values.teachers ?? [],
  };

  if (!teachingLoadFactor?.uuid) {
    return createTeachingLoadFactor({ input }, context);
  }
  return updateTeachingLoadFactor({ uuid: teachingLoadFactor.uuid, input }, context);
}
